export const SAVE_ISSUE_SCHEDULE_MODAL = 'issue_schedule';
